export const testSheetTypes = {
    FETCH_SUBMITTED_TEST_START: 'FETCH_SUBMITTED_TEST_START',
    FETCH_SUBMITTED_TEST_SUCCESS: 'FETCH_SUBMITTED_TEST_SUCCESS',
    FETCH_SUBMITTED_TEST_FAILURE: 'FETCH_SUBMITTED_TEST_FAILURE'
}